module.exports = __webpack_public_path__ + "static/img/00_click.097c11a1.png";